var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"background-box"},[_c('div',{staticClass:"play-machine"}),_c('div',{staticClass:"content-bg"},[_c('p',{staticClass:"desc"},[_vm._v(_vm._s(_vm.desc))]),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }